module.exports = import("https://static.cloud.coveo.com/atomic/v3.27.4/index.esm.js");;